var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column w-100 bg-light"},[_c('div',{staticClass:"print-container container mx-auto"},[_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col p-0"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }